// extracted by mini-css-extract-plugin
export default {"AboutInfoWrap":"AboutInfo_AboutInfoWrap__GPtnN","AboutInfoTitle":"AboutInfo_AboutInfoTitle__nJz9M","AboutInfoContent":"AboutInfo_AboutInfoContent__cqDpa"};